module.exports = __webpack_public_path__ + "img/BLANCO_Acompaniamiento.9910130c.png";